import Swal from 'sweetalert2'
import { mask } from 'vue-the-mask'
import API from '@/services/API'
import Assinatura from '@/services/Assinatura'
import Validacao from '@/services/Validacao'
import Usuario from '@/services/Usuario'
import Compartilhamento from '@/services/Compartilhamento'
import Armazenamento from '../../../../../services/Armazenamento';

const riscaValorAntigo = () => {
  const tabela = document.getElementsByClassName('el-table__body')
  const linha = tabela[0].getElementsByClassName('el-table__row')
  const campos = linha[0].getElementsByTagName('div')
  campos[1].setAttribute('class', 'cell line-through')
}

const mostraErroCupom = (cupom) => {
  Swal({
    title: `Validação de Cupom`,
    text: `O cupom utilizado: ${cupom.codigo} é invalido.`,
    type: 'error'
  })
}

const controller = {
  name: 'EditProfileFormCtrl',
  directives: {
    mask
  },
  data () {
    return {
      assinaturaInfo: null,
      bloquearDocumento: false,
      mostrarSecaoAssinatura: true,
      fullscreenLoading: false,
      compartilhado: {
        assinatura: Compartilhamento.assinatura
      },
      escolheCupom: false,
      cupom: null,
      tabelaPrecoColunas: [
        {
          label: 'Tipo',
          propriedade: 'tipo'
        },
        {
          label: 'Valor',
          propriedade: 'valor'
        }
      ],
      tabelaPrecoValores: [],
      tituloBotaoEnviar: 'Assinar',
      mostrarEndereco: false,
      estados: [],
      cidades: [],
      assinatura: {
        cupom: {
          codigo: ''
        }
      },
      usuario: {
        nome: '',
        sobrenome: '',
        documento: '',
        email: '',
        contato: {
          telefone: '',
          celular: ''
        },
        endereco: {
          cep: '',
          uf: '',
          cidade: '',
          logradouro: '',
          bairro: '',
          numero: '',
          complemento: ''
        },
        pagamento : {
          tipo: '',
	  pubkey: "-----BEGIN PUBLIC KEY-----\nMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAhGPzUFpar6aF3gfxrWBI\nqcMkDAL+bYaiVt0ssMtgg78luRj/4hWjv+stJx69NS1G42Fqqei1a5swIJmx2kPF\nzAo02XeGBzJLMLX3EkHfdkxnUIUR2ly+x8+3NaP5OblGz0yZu9XTXVOxYLPBOlEC\n3FhicnTZocL8X9VulPqNCSsi168/m45HO/8whjiqFFkdC0uJihkyEOdBh8YH4LW5\nbz7BaGttTZ8eUchvyJorneM4NCfYaZWv/h7nuWU50T6oL6kmyYixuNPsAEVd/EJp\nUMTihhbOxsANv750+Bzm1iKL7bWEpFrGqe5bZKJ9LiUU6fHBlilIWJD1BZanV/SG\nswIDAQAB\n-----END PUBLIC KEY-----",
          hash: '',
          numero: '',
          cvc: '',
          mes: '',
          ano: '',
          boleto: '',
          status: ''
        }
      }
    }
  },
  computed: {
    titulo () {
      return `Olá ${this.usuario.nome} ${this.usuario.sobrenome}`
    },
    rawCEP () {
      return this.usuario.endereco.cep.replace(/\D/g, '')
    }
  },
  methods: {
    estadoAlterado (uf) {
      if (uf) {
        this.usuario.endereco.cidade = ''
        API.CIDADES(uf)
          .then(response => {
            if (response.status === 200 && response.data) {
              this.cidades = response.data.map(cidade => {
                return { id: cidade.id, nome: cidade.nome }
              })
              this.cidades.sort((a, b) => a.nome > b.nome ? 1 : -1)
            }
          })
      }
    },
    showCEPInvalido () {
      Swal({
        title: `CEP não encontrado`,
        text: `Infelizmente não conseguimos encontrar o CEP: ${this.usuario.endereco.cep}. Deseja preencher os campos manualmente?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, preencher manualmente',
        cancelButtonText: 'Não, quero tentar de novo',
        reverseButtons: true
      }).then((result) => {
        if (result) {
          this.mostrarEndereco = true
        }
      })
    },
    showAtualizacaoInvalida (campos) {
      Swal({
        title: `Validação do formulário`,
        html: `<p>Os campos obrigatórios (*) estão vazios e/ou estão com dados inválidos</p>
              <ul>${campos}</ul>`,
        type: 'warning'
      })
    },
    buscarCEP () {
      const validaCEP = /^[0-9]{8}$/
      if (validaCEP.test(this.rawCEP)) {
        this.fullscreenLoading = true
        API.CEP(this.rawCEP)
          .then(response => {
            this.fullscreenLoading = false
            if (response.status === 200 && response.data && !response.data.erro) {
              const dados = response.data
              this.estadoAlterado(dados.uf)
              this.usuario.endereco.uf = dados.uf
              this.usuario.endereco.cidade = dados.localidade
              this.usuario.endereco.bairro = dados.bairro
              this.usuario.endereco.logradouro = dados.logradouro
              this.mostrarEndereco = true
            } else {
              this.mostrarEndereco = false
              this.showCEPInvalido()
            }
          })
          .catch(err => console.error(err))
      } else {
        Swal({
          title: `Validação de CEP`,
          text: `CEP: ${this.usuario.endereco.cep} inválido.`,
          type: 'error'
        })
      }
    },
    aplicarCupom () {
      this.fullscreenLoading = true
      API.cupom.validar(this.assinatura.cupom.codigo)
        .then(response => {
          this.fullscreenLoading = false
          if (response.status === 200 && response.data && response.data.valido) {
            this.cupom = response.data.cupom
            this.assinaturaInfo.method = this.cupom.method
            this.assinaturaInfo.type = this.cupom.type
            this.assinaturaInfo.eProductId = this.cupom.eProductId
            this.assinatura.cupom.codigo = this.cupom.codigo
            this.tabelaPrecoValores = [{
              tipo: 'Anual',
              valor: `R$ ${this.cupom.novoValor.atual}`,
              desconto: `${this.cupom.desconto}%`,
              novoValor: `R$ ${this.cupom.novoValor.comDesconto}`
            }]
            this.tabelaPrecoColunas.push({
              label: 'Desconto',
              propriedade: 'desconto'
            })
            this.tabelaPrecoColunas.push({
              label: 'Novo Valor',
              propriedade: 'novoValor'
            })
            riscaValorAntigo()
          } else {
            mostraErroCupom(this.assinatura.cupom)
          }
        })
        .catch(error => {
          this.fullscreenLoading = false
          console.error(error)
        })
    },
    validar () {
      const erros = []
      if (!this.usuario.nome) {
        erros.push(`<li>Nome</li>`)
      }

      if (!this.usuario.sobrenome) {
        erros.push(`<li>Sobrenome</li>`)
      }

      if (!this.usuario.documento) {
        erros.push(`<li>CPF / CNPJ</li>`)
      } else {
        if (this.usuario.documento.length <= 14 && !Validacao.cpf(this.usuario.documento)) {
          erros.push(`<li>CPF</li>`)
        } else if (this.usuario.documento.length > 14 && !Validacao.cnpj(this.usuario.documento)) {
          erros.push(`<li>CNPJ</li>`)
        }
      }

      if (!this.usuario.email) {
        erros.push(`<li>Email</li>`)
      }

      if (!this.usuario.contato.celular || !Validacao.celular(this.usuario.contato.celular)) {
        erros.push(`<li>Celular</li>`)
      }

      if (!this.usuario.endereco.cep || !Validacao.cep(this.usuario.endereco.cep)) {
        erros.push(`<li>CEP</li>`)
      }

      return erros
    },
    assinar100() {
      this.usuario.pagamento.tipo = "cupom100"
      this.atualizar()
    },
    pagarBoleto() {
      this.usuario.pagamento.tipo = "boleto"
      this.atualizar()
    },
    pagarCartao() {
      this.usuario.pagamento.tipo = "cartao"
      const erros = this.validar()
      if (erros.length > 0) {
        this.showAtualizacaoInvalida(erros.join(''))
      } else {
        MoipSdkJs.MoipCreditCard
        .setPubKey(this.usuario.pagamento.pubkey)
        .setCreditCard({
            number: this.usuario.pagamento.numero,
            cvc: this.usuario.pagamento.cvc,
            expirationMonth: this.usuario.pagamento.mes,
            expirationYear: this.usuario.pagamento.ano
        })
        .hash()
        .then(hash => {
          if(!hash) {
            Swal({
              title: `Atualização de dados`,
              html: `Houve um erro com os dados do cartão, erro USR-CR-002`,
              type: 'error'
            })
            return false
          }
          this.usuario.pagamento.hash = hash
          this.atualizar()
        })
        .catch(err => {
          Swal({
            title: `Atualização de dados`,
            html: `Houve um erro com os dados do cartão, erro USR-CR-002`,
            type: 'error'
          })
          console.log(err)
        })
      }
    },
    atualizar () {
      const erros = this.validar()
      if (erros.length > 0) {
        this.showAtualizacaoInvalida(erros.join(''))
      } else {
        this.fullscreenLoading = true
        this.usuario.liberarAcessoDezDias = true
        API.usuario.atualizar({
          usuario: this.usuario,
          cupom: this.cupom
        })
        .then(async response => {
          if (response.status === 200 && response.data) {
            // Atualizar dados da assinatura
            await Assinatura.atualizar()
            this.fullscreenLoading = false
            this.mostrarSecaoAssinatura = false
            if (this.tituloBotaoEnviar === 'Assinar') {
              if(this.cupom && this.cupom.novoValor && this.cupom.novoValor.comDesconto && this.cupom.novoValor.comDesconto == "0,00"){
                Swal({
                  title: `Assinatura`,
                  html: `Sua assinatura foi concretizada com sucesso`,
                  type: 'success'
                })  
              } else {
                if(this.usuario.pagamento.tipo == "boleto") {
                  const armAssinatura = Armazenamento.assinatura.pegar()
                  this.assinatura = armAssinatura.valor
                  this.usuario.pagamento.boleto = armAssinatura.valor.moipBoleto
                  this.usuario.pagamento.status = armAssinatura.valor.status
                  Swal({
                    title: `Assinatura`,
                    html: `Acesse o seu boleto <a href="`+armAssinatura.valor.moipBoleto+`" target="_blank"> clicando aqui</a>, 
                          após a validação do pagamento pelo nosso time, todas as funcionalidades serão liberadas!`,
                    type: 'success'
                  })
                } else {
                  Swal({
                    title: `Assinatura`,
                    html: `Sua assinatura encontra-se em revisão para aprovação, 
                          após a validação do pagamento pelo nosso time, todas as funcionalidades serão liberadas!`,
                    type: 'success'
                  })
                }
              }
            } else {
              Swal({
                title: `Atualização de dados`,
                html: `Dados atualizados com sucesso`,
                type: 'success'
              })
            }
            this.tituloBotaoEnviar = 'Atualizar'
          }
        })
        .catch(err => {
          this.fullscreenLoading = false
          Swal({
            title: `Atualização de dados`,
            html: `Houve um erro na atualização, favor contatar o suporte e informar o erro USR-CR-001`,
            type: 'error'
          })
          console.log(err)
        })
      }
    },
    atualizarComUsuario (cache) {
      const atualizar = (usuario) => {
        for (let [chave, valor] of Object.entries(usuario)) {
          if (chave === 'contato' && valor) {
            this.usuario.contato = valor
            continue
          }

          if (chave === 'endereco' && valor) {
            this.usuario.endereco = valor
            continue
          }

          if (valor) {
            this.usuario[chave] = valor
          }
        }

        if (this.usuario.endereco.cep !== '') {
          this.mostrarEndereco = true
        }

        this.fullscreenLoading = false
      }

      if (!cache) {
        Usuario.dados().then(dados => {
          const temp = dados.valor.usuario
          atualizar(temp)
        })
      } else {
        atualizar(cache)
      }
    }
  },
  mounted () {
    var appUrl = encodeURIComponent( document.location.href );
    var iframePlanos = document.createElement("iframe");
    iframePlanos.setAttribute("frameborder",0);
    iframePlanos.setAttribute("width","100%");
    iframePlanos.setAttribute("height",900);
    iframePlanos.src="https://irancho.superlogica.net/clients/areadocliente/publico/grades?id=9&url="+appUrl+"";
    document.getElementById("superlogica_planos_script").appendChild(iframePlanos);
  },
  created () {
    this.fullscreenLoading = true
    API.ESTADOS()
      .then(response => {
        if (response.status === 200 && response.data) {
          this.estados = response.data.map(estado => {
            return { id: estado.id, uf: estado.sigla }
          })
          this.estados.sort((a, b) => a.uf > b.uf ? 1 : -1)

          Assinatura.valor()
            .then(response => {
              if (response.status === 200 && response.data) {
                this.assinaturaInfo = response.data.assinatura
                this.tabelaPrecoValores = [{
                  tipo: 'Anual',
                  valor: `R$ ${this.assinaturaInfo.valor.toFixed(2).replace('.', ',')}`
                }]
              } else {
                this.tabelaPrecoValores = [{
                  tipo: 'Anual',
                  valor: 'R$ 360,00'
                }]
              }
            })

          Assinatura.buscar()
            .then(assinatura => {
              if (!assinatura) {
                this.atualizarComUsuario()
              } else {
                if (assinatura.status == 'desativado' || assinatura.status == 'vencida') {
                  this.tituloBotaoEnviar = 'Assinar'
                } else {
                  this.mostrarSecaoAssinatura = false
                  this.tituloBotaoEnviar = 'Atualizar'
                }
                  this.assinatura = assinatura
                this.bloquearDocumento = true
                this.atualizarComUsuario(assinatura.usuario)
              }
            })
        }
      })
  }
}

export default controller



// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/Pages/UserProfile/EditProfileFormCtrl.js